"use client";

import { SText } from "@/components/atoms";
import { footerLinks, socialLinks } from "@/constants/values";
import Link from "next/link";
import { usePathname } from "next/navigation";
import React from "react";
import { useTranslation } from "react-i18next";

const RenderSocialLinks = () => (
  <div className="flex justify-center space-x-4 mb-6">
    {socialLinks.map((link, index) => (
      <div key={`social-${index}`} className="rounded-full bg-lightBlue p-2">
        <Link
          href={link.href}
          target="_blank"
          aria-label={link.label}
          className="fill-white"
        >
          <link.icon />
        </Link>
      </div>
    ))}
  </div>
);

const RenderFooterLinks = () => {
  const { t, i18n } = useTranslation();
  const pathname = usePathname();
  const currentLocale = pathname.split("/")[1] || i18n.language;
  const links = footerLinks(t).map((link) => ({
    ...link,
    href:
      link.href.startsWith("http") || link.href.startsWith("//")
        ? link.href
        : `/${currentLocale}${link.href}`,
  }));

  return (
    <div className="mt-4 space-x-2 text-center">
      {links.map((link, index) => (
        <React.Fragment key={`footerLink-${index}`}>
          <Link href={link.href} className="hover:lightBlue underline">
            {link.label}
          </Link>
          {index < links.length - 1 && <span>•</span>}
        </React.Fragment>
      ))}
    </div>
  );
};

interface InfoSection {
  title: string;
  details: string[];
}

const Footer = () => {
  const { t } = useTranslation();
  const info_sections = t("home.info_sections", {
    returnObjects: true,
  }) as InfoSection[];

  return (
    <footer className="bg-primary text-white py-8 px-4">
      <div className="container mx-auto flex flex-col items-center">
        {RenderSocialLinks()}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full px-0 max-w-5xl">
          {info_sections.map((section, index1) => (
            <div
              key={`section-${index1}`}
              className="flex flex-col gap-2 text-center md:text-left"
            >
              <p
                className="font-bold text-base mb-2"
                dangerouslySetInnerHTML={{ __html: section.title }}
              />
              {section.details.map((detail, index2) => (
                <SText
                  key={`section-${index2}`}
                  text={detail}
                  color="white"
                  className="text-base"
                />
              ))}
            </div>
          ))}
        </div>
        <div className="mt-6">{RenderFooterLinks()}</div>
      </div>
    </footer>
  );
};

export default Footer;
